import { FC } from "react";
import { Heading, Stack, Text } from "@chakra-ui/react";

import { ICooling } from "../../../../api/cooling/types.ts";
import { getHourWord, isStringWithNumber } from "../../../../utils";

interface Props {
  limitInfo: ICooling["limitInfo"];
}

export const CoolingPageText: FC<Props> = ({ limitInfo }) => {
  const name = limitInfo?.firstName ? `${limitInfo.firstName},` : "";
  const hours = typeof limitInfo?.cooldownHours === "number" && limitInfo.cooldownHours > 0
    ? limitInfo.cooldownHours
    : "...";
  const hoursWord = isStringWithNumber(hours) ? getHourWord(hours as number) : "часов";

  const text = `Согласно Федеральному Закону 353-ФЗ, финансовые организации не вправе зачислять 
                       денежные средства в течение ${hours} ${hoursWord} после подписания документов`;

  return (
    <Stack spacing={0} pt="16px" alignItems="center" textAlign="center">
      <Heading lineHeight="1">{name}</Heading>
      <Heading mb="8px">Ваш заём успешно оформлен!</Heading>

      <Text textAlign="center" maxW="308px">{text}</Text>
    </Stack>
  );
};
